import { applyMiddleware, compose, createStore } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from './reducers'
import sagas from './sagas'

export default function configureStore(history) {
  const saga = createSagaMiddleware()

  const buildStore = createStore(
    connectRouter(history)(rootReducer),
    composeWithDevTools(
      compose(
        applyMiddleware(
          routerMiddleware(history), // for dispatching history actions
          saga
        ),
      )
    )
  )

  saga.run(sagas)

  return buildStore
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js